const messages = {
  name: 'Gestionar Grupos',
  pageTitle: 'Gestionar Grupos',
  empty: 'No se han encontrado grupos',
  fields: {
    account: 'Cuenta',
    application: 'Aplicacion',
    groupName: 'Nombre del Grupo',
    accountName: 'Nombre de la Cuenta',
    applicationName: 'Nombre de la Aplicacion',
  },
  placeholders: {
    selectAccount: 'Selecciona una cuenta',
    selectApplication: 'Selecciona una aplicacion',
  },
  search: {
    placeholder: 'Buscar',
  },
  filters: {
    groupName: 'Nombre del Grupo',
    accountName: 'Cuenta',
    applicationName: 'Aplicacion',
  },
  hints: {
    pickAccountFirst: 'Selecciona una cuenta para cargar sus aplicaciones',
    pickAccountAndApplication:
      'Selecciona una cuenta y una aplicacion para gestionar sus grupos',
    noApplications: 'No hay aplicaciones asignadas a esta cuenta',
  },
  actions: {
    addGroup: 'Anadir Grupo',
    edit: 'Editar',
    delete: 'Eliminar',
    back: 'Volver',
    submit: 'Guardar',
    discard: 'Descartar',
  },
  delete: {
    title: 'Eliminar %{name}?',
    content:
      'Estas seguro de que quieres eliminar este grupo? Esta accion no se puede deshacer.',
  },
  validation: {
    accountRequired: 'La cuenta es obligatoria',
    applicationRequired: 'La aplicacion es obligatoria',
    atLeastOneGroup: 'Se requiere al menos un grupo',
    groupNameRequired: 'El nombre del grupo es obligatorio',
  },
  notifications: {
    loadFailed: 'No se pudieron cargar los grupos',
    saveFailed: 'No se pudieron guardar los grupos',
    saved: 'Grupos guardados correctamente',
    deleted: 'Grupo "%{name}" eliminado',
    deleteFailed: 'No se pudo eliminar el grupo',
  },
};

export default messages;
